import storage from "store2";
import TicketsView from "../../components/Tickets/TicketsView";

let initialState = {
  columns: [
    {key: "CardID", displayName: "Booking ID"},
    {key: "ActionDate", displayName: "Booking Date", type: "date"},
    //customer
    {key: ["UserName", "UserEmail"], displayName: "Customer"},
    //route
    {key: ["myTrips.0.TripOfficeFrom", "myTrips.0.TripOfficeTo"], displayName: "Route"},
    {key: "CardTotalPrice", displayName: "Price"},
    {key: "CardTypeID", displayName: "Payment Type", filter: true, replace: [{key: 3, value: TicketsView.cards.credit_card}, {key: 1, value: TicketsView.cards.delivery}, {key: 2, value: TicketsView.cards.fawry}/*, {key: 3, value: TicketsView.cards.aman}*/]},
    {key: "CardStatusID", displayName: "Status", filter: true, replace: [{key: 4, value: TicketsView.status.approved}, {key: 3, value: TicketsView.status.pending}]},
  ],
  tickets: [],
  new_tickets_ids: [],
  filtered_tickets: null,
  total_price: 0,
  filters: {
    CardTypeID: [],
    CardStatusID: [],
    ActionDate: null
  },
  difference: 0,
  done_setting_tickets: false,
  page: 1,
  total_pages: 0
}

export default function (state = initialState, action) {
  switch(action.type) {
    case SET_TICKETS:
      return {
        ...state,
        tickets: action.tickets,
        new_tickets_ids: [],
        total_pages: action.total_pages,
        total_price: action.totalPrice
        // done_setting_tickets: true
      }

    case UPDATE_TICKETS:
      return {
        ...state,
        tickets: action.tickets,
        new_tickets_ids: action.newTicketsIDs,
        total_price: action.totalPrice
      }

    case OLDIFY_TICKET: {
      return {
        ...state,
        new_tickets_ids: action.new_tickets_ids
      }
    }

    case SELECT_PAGE:
      return {
        ...state,
        page: action.page,
      }

    case SET_FILTERED_TICKETS:
      return {
        ...state,
        filtered_tickets: action.filteredTickets,
        total_price: action.totalPrice,
        page: {
          ...state.page,
          current_page: 1,
          max_pages: Math.ceil(action.ticketsLength/state.page.length),
          start: 0,
        },

        filtered_by_id: action.isByID
      }
    
    case SET_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filters
        }
      }  

    case REMOVE_FILTERS:
      return {
        ...state,
        filtered_tickets: null
      }

    case CLEAR_TICKETS_LOADERS:
      return {
        ...state,
        done_setting_tickets: false
      }
    
    default: return {...state};
  }
}


// Action types
export const SET_TICKETS = "SET_TICKETS";
export const UPDATE_TICKETS = "UPDATE_TICKETS";
export const OLDIFY_TICKET = "OLDIFY_TICKET";
export const SELECT_PAGE = "SELECT_PAGE";
export const SET_FILTERED_TICKETS = "SET_FILTERED_TICKETS";
export const REMOVE_FILTERS = "REMOVE_FILTERS";
export const CLEAR_TICKETS_LOADERS = "CLEAR_TICKETS_LOADERS";
export const SET_FILTERS = "SET_FILTERS";